import React, { useEffect, useMemo, useRef, useState } from "react";
import type { ReactElement } from "react";
import { Route, useLocation } from "react-router";
import getRoutesArray from "../routes";
import { useUserRole } from "../services/userServices/useUserRole";
import AuthView from "./AuthView";

const AuthContainer = () => {
  const location = useLocation();
  const role = useUserRole();
  const mainContentRef = useRef<HTMLDivElement | null>(null);

  const [routesArr, setRoutesArr] = useState<ReturnType<typeof getRoutesArray>>([]);
  const [redirectToWildcard, setRedirectToWildcard] = useState(false);


  // SCRUM-1172: the role comes from Redux (useUserRole) instead of localStorage.
  // Deliberately still mount-only, exactly as before -- see AdminContainer.
  useEffect(() => {
    const routes = getRoutesArray(role);
    setRoutesArr(routes);

    document.body.classList.add("bg-default");
    setRedirectToWildcard(true);

    return () => {

      document.body.classList.remove("bg-default");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    if (mainContentRef.current) mainContentRef.current.scrollTop = 0;
  }, [location]);


  const routeElements = useMemo(() => {
    const out: ReactElement[] = [];
    const walk = (arr: any[]) => {
      arr.forEach((r) => {
        if (r.collapse && Array.isArray(r.views)) {
          walk(r.views);
          return;
        }
        if (r.layout === "/auth") {
          out.push(<Route key={`${r.layout}${r.path}`} path={r.path} element={<r.component />} />);
        }
      });
    };
    walk(routesArr);
    return out;
  }, [routesArr]);

  const ViewModel = useMemo(
    () => ({
      mainContentRef,
      routeElements,
      redirectToWildcard,
    }),
    [routeElements, redirectToWildcard]
  );

  return <AuthView {...ViewModel} />;
};

export default AuthContainer;
